import React from "react";
import LineChart from "../Chart/LineChart";
import BarChart from "../Chart/BarChart";
import StackedBarChart from "../Chart/StackedBarChart";

class ChartComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  toPercent = (value) => `${value}%`;
  renderChart(param) {
    const commonProps = {
      onclick: this.props.onclick,
      chartConfig: this.props.chartConfig,
      data: this.props.data
    }
    switch (param) {
      case "line":
        return <LineChart
          {...commonProps}
        />
      case "bar":
        return <BarChart
          {...commonProps}
          checked={this.props.checked}
          toPercent={this.toPercent}
        />
      case "stackedBar":
        return <StackedBarChart
          {...commonProps}
          checked={this.props.checked}
        />
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <p className={classes.chartLabel}> {this.props.chartConfig.title}</p>
        <div style={this.props.chartConfig.ChartStyle}>
          {this.props.data && this.renderChart(this.props.chartConfig.chartType)}
        </div>
      </div>
    );
  }
}

export default ChartComponent;